export default __webpack_public_path__ + "static/media/InactiveUnion.a8ca3ad2.svg";